/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RegistrationRequestIntroductionMethod {
    SALE_OPERATOR = 'SaleOperator',
    INTERNET = 'Internet',
    WORD_OF_MOTH = 'WordOfMoth',
    OTHERS = 'Others',
    SOCIAL_MEDIA = 'SocialMedia',
}
